import { v4 as newGuid } from 'uuid';
import { Command } from 'commands/Commands';
import { BusinessAddress } from 'models/business';

export class AddBusinessAddress extends Command {
  type: string = 'AddBusinessAddress';
  priority: number = 100;

constructor(public payload: BusinessAddress, id: string = newGuid()) {
    super(payload, id);
  }
}